export const STORE = 'TERMINALS';
export const GET_TERMINALS = 'GET_TERMINALS';
export const SET_TERMINALS = 'SET_TERMINALS';
export const ERROR_LOAD_TERMINALS = 'ERROR_LOAD_TERMINALS';
export const SUCCESS_LOAD_TERMINALS = 'SUCCESS_LOAD_TERMINALS';
export const GET_LOADING_TERMINALS = 'GET_LOADING_TERMINALS';
export const SET_LOADING_TERMINALS = 'SET_LOADING_TERMINALS';
